import { createContext } from "react";

import { ITrxnShimmerContext } from "Views/Transaction/@types";

export const initialTrxnShimmer: ITrxnShimmerContext = {
  loading: false,
};

export const TrxnShimmerContext = createContext<ITrxnShimmerContext>(initialTrxnShimmer);
